import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { WebgateProvider } from '@xvia/webgate-connect';
import './icons';
import { ThemeProvider } from '@mui/material';
import { theme } from './theme';

const rootElement = document.getElementById('root');

// Detects if it's a SPA navigation (when the portal is already loaded)
// or a direct page load (pure SSR)
const isPortalSPANavigation =
  typeof window !== 'undefined' && window.__XVIA_PORTAL_LOADED__ === true;

// Only hydrate on direct load (not SPA)
// On SPA navigation, the HTML may have been generated for another route or be inconsistent
const shouldHydrate =
  !isPortalSPANavigation &&
  rootElement &&
  rootElement.children.length > 0 &&
  rootElement.innerHTML.trim() !== '';

/**
 * Gets the basename from the current URL path.
 * Falls back to extracting it from the URL if window.__APP_BASE__ is not set.
 */
function getBasename(): string {
  // First check if portal has set the base
  if (window.__APP_BASE__ && window.__APP_BASE__ !== '/') {
    return window.__APP_BASE__;
  }

  // Fallback: extract from current URL for /app/{slug} pattern
  const pathname = window.location.pathname;
  const appMatch = pathname.match(/^(\/app\/[^/]+)/);
  if (appMatch) {
    return appMatch[1];
  }

  return '/';
}

function renderApp() {
  const baseName = getBasename();

  const AppComponent = (
    <React.StrictMode>
      <BrowserRouter basename={baseName}>
        <WebgateProvider portalUrl={process.env.PORTAL_URL as string}>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </WebgateProvider>
      </BrowserRouter>
    </React.StrictMode>
  );

  if (rootElement) {
    if (shouldHydrate) {
      // Direct load with SSR - hydrate to preserve server state
      ReactDOM.hydrate(AppComponent, rootElement);
    } else {
      // SPA navigation or no SSR content - clear content and render
      // This avoids hydration mismatch issues
      rootElement.innerHTML = '';
      ReactDOM.render(AppComponent, rootElement);
    }
  }
}

// Render the app - the basename is now correctly extracted from URL if needed
renderApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
